import type {
	CustomItem,
	DropHybridProductCardGridType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropHybridProductCardGrid = (
	item: Item | CustomItem
): item is DropHybridProductCardGridType => {
	return !!(item && item.__typename === 'Drop_Hybrid_Product_Card_Grid');
};
